// extracted by css-extract-rspack-plugin
export default {"titleBox":"titleBox-Q0QkY5","titleFont":"titleFont-HgQ2rF"};